export default __webpack_public_path__ + "bd64db130418b81844affc37912ee426.svg";